<div [ngClass]="theme.getThemeClass()" class="chart-container">
  <ngx-charts-line-chart
    [results]="charts.logLineChartData"
    [view]="charts.logLineChartView"
    [scheme]="charts.colorSchemeLineChart"
    [xAxis]="true"
    [yAxis]="true"
    [legend]="false"
    [autoScale]="true"
    [timeline]="false"
    [animations]="false"
    [showXAxisLabel]="false"
    [showYAxisLabel]="true"
    [yAxisLabel]="charts.logLineYAxisLabel"
    [xAxisTickFormatting]="charts.formatLogLineXAxis"
    (select)="charts.onSelectLineChart($event)"
    (activate)="charts.onActivateLineChart($event)"
    (deactivate)="charts.onDeactivateLineChart($event)"
  >
  </ngx-charts-line-chart>
</div>
